// Use the configured backend directly on every hosting platform and on localhost.
export const getPlexUrl = (apiBaseUrl: string) => {
  const url = new URL(apiBaseUrl.trim().replace(/^['"]|['"]$/g, ''))

  if (url.protocol === 'https:') url.protocol = 'wss:'
  else if (url.protocol === 'http:') url.protocol = 'ws:'
  if (url.protocol !== 'wss:' && url.protocol !== 'ws:') {
    throw new Error('Plex URL must use HTTP(S) or WS(S)')
  }
  url.pathname = `${url.pathname.replace(/\/$/, '')}/plex`
  url.search = ''
  url.hash = ''

  return url.toString()
}

export const withPlexQueryAuth = (
  baseUrl: string,
  name: 'x-api-key' | 'token',
  value: string,
  tenantId: string,
) => {
  const url = new URL(baseUrl)
  url.searchParams.set(name, value)
  url.searchParams.set('tenant-id', tenantId)
  return url.toString()
}
